export default __webpack_public_path__ + "static/media/shopping.47772a85.png";